/* Fix for pagefly prod pages cart drawer refresh */
try {
setTimeout(function () {
  window.__pagefly_helper_store__ &&
    window.__pagefly_helper_store__.subscribe(function (res) {
    $.getJSON('/cart.json').then(cart => {
          var header = document.querySelector('sticky-header');
          var item = document.querySelector('#cart-notification #cart-notification-product');
          var button = document.querySelector('#cart-notification #cart-notification-button');
          const cartBubble = `<div class="cart-count-bubble"><span aria-hidden="true">1</span></div>`
          var notification = document.getElementById('cart-notification');
          var html = `<img class="cart-notification-product__image" src="" alt="" width="70" height="70" loading="lazy">
                        <div class="cart-notification-product__info">
                          <h3 class="cart-notification-product__name h4"></h3></div>`
          var tempHTL = document.createElement('div');
          tempHTL.innerHTML = html
          tempHTL.querySelector('img').src = res.image
          tempHTL.querySelector('.cart-notification-product__name').innerHTML = res.title
          item.innerHTML = tempHTL.innerHTML
          if($('.cart-count-bubble').length > 0) {
              $('.cart-count-bubble span').text(cart.item_count)
          } else {
              $('#cart-icon-bubble').append(cartBubble);
          }
          button.innerText = `View my cart (${cart.item_count})`
          notification.classList.add('animate', 'active');
          addEventListener('transitionend', () => {
          notification.focus();
          trapFocus(notification);
        }, { once: true });
                    });

          
});
}, 2500);
} catch (e) {
console.warn(e);
}